<div class="max-h-[90vh]" data-testid="custom-update-modal">
  <h3 nxHeadline class="nx-font-weight-semibold" size="s">
    {{ 'custom-update.rep-risk.title' | translate }}
  </h3>
  <div class="mt-3">
    <span class="nx-font-weight-semibold">{{ 'update.modal.date' | translate }}</span> {{ todaysDate }}
  </div>
  @if (step === 'quiz') {
    <form class="mt-3 mb-3" [formGroup]="quizForm">
      <nx-radio-group formControlName="controversial">
        <nx-label size="small" class="nx-margin-bottom-s nx-font-weight-semibold">{{
          'custom-update.rep-risk.question.controversial' | translate
        }}</nx-label>
        <nx-radio labelSize="small" value="yes" class="nx-margin-bottom-m">{{
          'custom-update.rep-risk.yes' | translate
        }}</nx-radio>
        <nx-radio labelSize="small" value="no" class="nx-margin-bottom-m">{{
          'custom-update.rep-risk.no' | translate
        }}</nx-radio>
      </nx-radio-group>
      <nx-radio-group formControlName="alert">
        <nx-label size="small" class="nx-margin-bottom-s nx-font-weight-semibold">{{
          'custom-update.rep-risk.question.alert' | translate
        }}</nx-label>
        <nx-radio labelSize="small" value="yes" class="nx-margin-bottom-m">{{
          'custom-update.rep-risk.yes' | translate
        }}</nx-radio>
        <nx-radio labelSize="small" value="no" class="nx-margin-bottom-m">{{
          'custom-update.rep-risk.no' | translate
        }}</nx-radio>
      </nx-radio-group>
      <nx-radio-group formControlName="search">
        <nx-label size="small" class="nx-margin-bottom-s nx-font-weight-semibold"
          >{{ 'custom-update.rep-risk.question.search' | translate }}
        </nx-label>
        <nx-radio labelSize="small" value="yes" class="nx-margin-bottom-m">{{
          'custom-update.rep-risk.yes' | translate
        }}</nx-radio>
        <nx-radio labelSize="small" value="no" class="nx-margin-bottom-m">{{
          'custom-update.rep-risk.no' | translate
        }}</nx-radio>
      </nx-radio-group>
      <nx-radio-group formControlName="guideline">
        <nx-label size="small" class="nx-margin-bottom-s nx-font-weight-semibold"
          >{{ 'custom-update.rep-risk.question.guideline' | translate }}
        </nx-label>
        <nx-radio labelSize="small" value="yes" class="nx-margin-bottom-m">{{
          'custom-update.rep-risk.yes' | translate
        }}</nx-radio>
        <nx-radio labelSize="small" value="no">{{ 'custom-update.rep-risk.no' | translate }}</nx-radio>
      </nx-radio-group>
      @if (atLeastOneYes) {
        <nx-message context="warning" class="mt-7">
          {{ 'custom-update.rep-risk.one-yes' | translate }}
        </nx-message>
      }
    </form>
  } @else if (step === 'risk') {
    <form class="mt-3" [formGroup]="riskForm">
      <div class="mb-3">
        <span nxCopytext class="nx-font-weight-semibold">{{ 'custom-update.rep-risk.risk-label' | translate }}</span>
        (
        <nx-link size="small"
          ><a href="{{ REP_RISK_SHARE_POINT_LINK }}" target="_blank" rel="noopener">{{
            'custom-update.rep-risk.risk-definition.link-label' | translate
          }}</a></nx-link
        >
        ).
      </div>
      <nx-radio-group formControlName="averageRiskScore" (groupValueChange)="onRiskScoreChange($event.value)">
        <div class="mb-3.5">
          <nx-label size="small" class="nx-font-weight-semibold !inline">{{
            'custom-update.rep-risk.question.average-risk' | translate
          }}</nx-label>
          <span nxCopytext="normal" class="nx-font-weight-light italic">
            {{ 'custom-update.rep-risk.question.average-risk.disclaimer' | translate }}
          </span>
        </div>

        <nx-radio labelSize="small" value="1" class="nx-margin-bottom-m">1</nx-radio>
        <nx-radio labelSize="small" value="2" class="nx-margin-bottom-m">2</nx-radio>
        <nx-radio labelSize="small" value="3" class="nx-margin-bottom-m">3</nx-radio>
        <nx-radio labelSize="small" value="4" class="nx-margin-bottom-m">4</nx-radio>
        <nx-radio labelSize="small" value="5">5</nx-radio>
      </nx-radio-group>
      <nx-message context="info" class="mt-7 nx-margin-bottom-m">
        {{ 'custom-update.rep-risk.info.document' | translate }}
      </nx-message>
      <kyc-file-uploader
        [value]="documents"
        (fileDeletion)="onFileDeletion($event)"
        (filesChange)="onFilesChange($event)"
      />
      @if (documentIds) {
        <kyc-document-list [documentIds]="documentIds" />
      }
      @if (isEscalationRequired) {
        <nx-message context="warning" class="mt-7 mb-3.5">
          <span>{{ 'custom-update.rep-risk.warn.escalation' | translate }}</span>
          <br /><br />
          <span class="mr-3">{{ 'custom-update.rep-risk.warn.risk-form' | translate }}</span>
          <nx-link size="small"
            ><a href="{{ REP_RISK_SHARE_POINT_LINK }}" target="_blank" rel="noopener">{{
              'custom-update.rep-risk.risk-definition.link-label' | translate
            }}</a></nx-link
          >
        </nx-message>
        @if (data.hasEscalationEmailInput) {
          <nx-formfield [label]="'update.modal.escalate-email' | translate" appearance="outline" floatLabel="always">
            <input nxInput email required formControlName="email" type="email" />
          </nx-formfield>
        }
        <nx-formfield
          class="mt-3"
          [label]="'escalate.modal.comment-optional' | translate"
          floatLabel="always"
          appearance="outline"
        >
          <textarea rows="5" formControlName="comment" spellcheck="false" nxInput type="text"></textarea>
        </nx-formfield>
        <div class="flex justify-end">
          <button
            (click)="save()"
            nxButton="secondary small-medium"
            type="button"
            [disabled]="isSaving"
            class="flex align-middle"
          >
            @if (isSaving) {
              <nx-spinner />
            } @else {
              {{ 'custom-update.rep-risk.button.save' | translate }}
            }
          </button>
        </div>
        @if (savingError) {
          <nx-message context="error" class="my-3">{{ 'custom-update.rep-risk.save-error' | translate }}</nx-message>
        }
      }
    </form>
  }
  <div class="flex justify-center">
    <button (click)="next()" [disabled]="isNextDisabled" nxButton="small-medium" type="button">
      {{ 'custom-update.rep-risk.button.next' | translate }}
    </button>
  </div>
  <div class="flex justify-center mt-3.5">
    @if (step === 'quiz') {
      <button (click)="data.closeModal()" nxButton="tertiary small-medium" type="button">
        {{ 'custom-update.rep-risk.button.dismiss' | translate }}
      </button>
    } @else {
      <button (click)="previous()" nxButton="tertiary small-medium" type="button" class="mb-4">
        {{ 'custom-update.rep-risk.button.previous' | translate }}
      </button>
    }
  </div>
</div>
